module.exports = __webpack_public_path__ + "img/cfs-finder.b3d29b77.png";